// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "gessica-andrade.firebaseapp.com",
  "projectId": "gessica-andrade",
  "storageBucket": "gessica-andrade.appspot.com",
  "messagingSenderId": "190666210816",
  "appId": "1:190666210816:web:376b7224b292f0974fa2e5",
  "measurementId": "G-FDW0P037GE",
  "apiKey": "AIzaSyDYV15rDsvkChFZ8fKuoakdaffUFnnXGNU"
};
